import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouseGbp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28.65 16.74l1.6 1.2v-2.69h1v3.44l.4.3L35 21.5V35h-9.25v-5a3.25 3.25 0 00-6.5 0v5H13V21.5l11-8.25 4.65 3.49z",
		stroke: "#1B5E20",
		strokeWidth: 2
	})
});
export default SvgHouseGbp;
